<template>
  <div class="calendario mb-2">
    <div class="fc fc-ltr fc-grid row mx-n1">
      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">NEM</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderaciones.nem }}%</div>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Ranking</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderaciones.ranking }}%</div>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Competencia Lectora</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderaciones.lenguaje }}%</div>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Competencia Matemática 1</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderaciones.matematicas1 }}%</div>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number d-flex align-items-center">
          <span class="mx-auto">Competencia Matemática 2</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderacionMatematica2 }}</div>
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number-special d-flex align-items-center">
          <span class="mx-auto">Historia y Cs. Sociales</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderaciones.historia }}%</div>
        </div>
      </div>

      <div
        v-if="mostrarO"
        class="p-1"
        style="align-items: center; margin-top: 44px!important;"
      >
        <div>
          O
        </div>
      </div>

      <div class="col p-1" style="min-height: 53px">
        <div class="fc-day-number-special d-flex align-items-center">
          <span class="mx-auto">Ciencias</span>
        </div>
        <div class="fc-day-content">
          <div style="height: 29px">{{ ponderaciones.ciencias }}%</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Ponderaciones",
  props: {
    ponderaciones: {
      type: Object
    }
  },
  computed: {
    ponderacionMatematica2() {
      let ponderacion = this.ponderaciones.matematicas2;

      if (ponderacion === "" || ponderacion === 0) {
        return "-";
      }
      ponderacion =
        this.ponderaciones.matematicas2 > 0
          ? `${this.ponderaciones.matematicas2}%`
          : "HABILITA";
      return ponderacion;
    },
    mostrarO() {
      return this.ponderaciones.historia > 0 && this.ponderaciones.ciencias > 0;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/fichaCarreraU/Ponderaciones.vue